import React, { useState } from "react";
import "./App.css";

function App() {

  const [cityName, setCityName] = useState("");
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const fetchWeather = async () => {

    if (!cityName) return;

    setIsLoading(true);
    setErrorMsg("");
    setData(null);

    try {

      // Get coordinates
      const geoRes = await fetch(
        `https://geocoding-api.open-meteo.com/v1/search?name=${cityName}`
      );

      const geo = await geoRes.json();

      if (!geo.results) {
        throw new Error("Invalid city name");
      }

      const { latitude, longitude, name } = geo.results[0];

      // Get weather data
      const weatherRes = await fetch(
        `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`
      );

      const weather = await weatherRes.json();

      setData({
        city: name,
        temp: weather.current_weather.temperature,
        wind: weather.current_weather.windspeed
      });

    } catch (err) {

      setErrorMsg(err.message);

    }

    setIsLoading(false);
  };

  const getWeatherEmoji = (temp) => {
    if (temp >= 32) return "🔥";
    if (temp >= 25) return "🌞";
    if (temp >= 18) return "🌥️";
    if (temp >= 10) return "🌫️";
    return "🥶";
  };

  return (

    <div className="layout">

      <div className="panel">

        <h2>Weather App</h2>

        <input
          type="text"
          placeholder="Search city..."
          value={cityName}
          onChange={(e) => setCityName(e.target.value)}
        />

        <button onClick={fetchWeather}>
          Get Weather
        </button>

        {isLoading && <p className="loading">Loading data...</p>}

        {errorMsg && <p className="error">{errorMsg}</p>}

      </div>

      {data && (
        <div className="display">

          <div className="emoji">
            {getWeatherEmoji(data.temp)}
          </div>

          <h3>{data.city}</h3>

          <p className="temp">{data.temp}°C</p>

          <p>Wind Speed: {data.wind} km/h</p>

        </div>
      )}

    </div>

  );
}

export default App;